import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_tinhchatnguonkp, Lists_manguonnsnn, Lists_caphat } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-nguonkinhphiedit',
  templateUrl: './nguonkinhphiedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./nguonkinhphiedit.component.scss'],
    providers: [ListService, Repository]
})


export class nguonkinhphieditComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    
    inputparents: any;
    inputtinhchats: any;
    inputmanguons: any;
    inputcapphats: any;
    indLoading: boolean = false;    
    doituongSelect: any = { Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:null,Nhom_Doi_Tuong_ID:null,Don_Vi_Id:null,Ma_Ao:null,
      Tinh_Chat_Id: null, Ma_Nguon_Id: null, Cap_Phat_Ngam_Dinh_Id: null, Ma_So_NS: null};    
    nhomdtid: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };


    @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('slTinhChat', { static: false }) slTinhChat: NgSelectComponent;
  @ViewChild('slMaNguon', { static: false }) slMaNguon: NgSelectComponent;
  @ViewChild('slCapPhat', { static: false }) slCapPhat: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        let data = JSON.parse(authlogin);
        var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/'+id+'/'+donviid)
        .subscribe(response => {            
            this.inputparents=response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_tinhchatnguonkp.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputtinhchats = response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_manguonnsnn.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputmanguons = response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_caphat.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputcapphats = response;
        });
      

      this.doituongSelect = {
        Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null, Ghi_Chu: null, Parent: null, Trang_Thai: null, Nhom_Doi_Tuong_ID: nhomdoituongid, Don_Vi_Id: donviid, Ma_Ao: null,
        Tinh_Chat_Id: null, Ma_Nguon_Id: null, Cap_Phat_Ngam_Dinh_Id: null, Ma_So_NS: null   
      };    
        
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
        }
        else {
            console.log(id);
          this.repo.getRequest("api/doituongnguonkinhphi/getbyid/" + id)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id = id;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;

              this.doituongSelect.Tinh_Chat_Id = response.Tinh_Chat_Id;
              this.doituongSelect.Ma_Nguon_Id = response.Ma_Nguon_Id;
              this.doituongSelect.Cap_Phat_Ngam_Dinh_Id = response.Cap_Phat_Ngam_Dinh_Id;
              this.doituongSelect.Ma_So_NS = response.Ma_So_NS;
              }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }
      console.log(this.doituongSelect);
      this.repo.postRequest("api/doituongnguonkinhphi/addorupdate",this.doituongSelect)
            .subscribe(response => {  
              console.log(response);
              if (response.indexOf("-") !== -1) {
                this.doituongSelect.Id = response;
                this.save.emit(this.doituongSelect);
              }
              else
                swal('Lỗi!', response, 'error');
            }); 
    }
   
    
   

   


}
